import { PlannedDemandPageThemeModeConfig } from './types';

const light: PlannedDemandPageThemeModeConfig = {
  plannedDemandPage: {
    normalButtonBGColor: '#0775bc',
    normalButtonBorderColor: '2px solid #267DAC',
  },
};

export default light;
